<template>
	<div class="list">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <ul>
        <li v-for="item of list">
          <van-cell-group inset>
            <van-cell :title="item.meetingname" value="" />
            <van-cell @click="godetail(item)">
              <template #title>
                <p class="title flex"><span class="flex-s">开始时间</span>{{item.starttime}}</p>
                <p class="title flex"><span class="flex-s">结束时间</span>{{item.endtime}}</p>
                <p class="title flex"><span class="flex-s">地点</span>{{item.meetingaddress}}</p>
                <p class="title flex"><span class="flex-s">范围</span>{{item.range}}米</p>
                <p class="title flex" :class="{'green' : item.status == 1, 'black': item.status == 0 || item.status == 2}">
                  <span class="flex-s">会议状态</span>{{item.status == 0 ? '未开始'
                  : item.status == 1 ? '进行中' : '已结束'}}</p>
              </template>
            </van-cell>
            <van-cell is-link>
              <template #title>
                <van-button type="default" @click.stop="govipGiftData(item)">礼包数据</van-button>
              </template>
            </van-cell>
          </van-cell-group>
        </li>
      </ul>
    </Scroller>
    <div class="footer footerIOS">
      <van-button type="primary" block color="linear-gradient(90deg, #FB6E38 0%, #FE9B4B 100%)" @click="goApply">新建会议</van-button>
      <div class="h"></div>
    </div>
  </div>
</template>

<script>
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: "meetinglist",
  data () {
    return {
      list: [],
      refresh: false,
      loading: false,
      finished: false,
	  noDataText: '',
      nowPage: 0,
    }
  },
  components: {
    Scroller
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        Object.assign(vm.$data, vm.$options.data());
	      if (isWeixin()) {
		      fenxiang({path: 'meetingloginin'})
	      }
      })
    } else {
      next(vm => {
        if (from.path == '/') {
          Object.assign(vm.$data, vm.$options.data());
        }
	      if (isWeixin()) {
		      fenxiang({path: 'meetingloginin'})
	      }
        if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, false)
          }, 0) // 同步转异步操作
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData () {
      var that = this, url = 'Wxmall/VipGift/getMeetList?meetingid=2&pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&loginmobile=' + (sessionStorage.getItem('meetinglogin_mobile') ? sessionStorage.getItem('meetinglogin_mobile') : '')

      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          if (that.nowPage === 1) {
          	if (res.data.listdata.length > 0) {
			  that.noDataText = '暂无数据~'
          	} else {
			  that.noDataText = ''
			}
            that.list = res.data.listdata
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.listdata)
          }
          that.loading = false
          if (res.data.listdata.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    govipGiftData (item) {
      this.$router.push('/vipgiftbagdata?meetingid=' + item.meetingid)
    },
	godetail (item) {
	  setTimeout(() => {
		this.$router.push('/meetingdetail?meetingid=' + item.meetingid)
	  }, 500)
	},
    goApply () {
      this.$router.push('/applymeeting')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/createmeeting";
  .list {
	  padding-bottom: 0.8rem;
    ul {
      li {
        margin-top: 0.1rem;
        &:last-of-type {
          margin-bottom: 0.1rem;
        }
      }
    }
  }
  .title {
    margin-top: 0.12rem;
    color: #333333;
    &.green {
      color: #32C25A;
    }
    &.black {
      font-weight: bold;
    }
    span {
      width: 0.75rem;
      color: #666666;
    }
  }
  .footer {
    background: #ffffff;
    padding: 0.1rem 0.15rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    .van-button--primary {
      border-radius: 0.25rem;
    }
    .h {
      height: 0.1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/createmeeting/meetinglist.vue